<template>
  <path
    d="M19 3.00018H14.82C14.4 1.84018 13.3 1.00018 12 1.00018C10.7 1.00018 9.6 1.84018 9.18 3.00018H5C3.9 3.00018 3 3.90018 3 5.00018V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00018C21 3.90018 20.1 3.00018 19 3.00018ZM12 3.00018C12.55 3.00018 13 3.45018 13 4.00018C13 4.55018 12.55 5.00018 12 5.00018C11.45 5.00018 11 4.55018 11 4.00018C11 3.45018 11.45 3.00018 12 3.00018ZM11.65 17.6502L7 13.0002H10V9.00018H14V13.0002H17L12.35 17.6502C12.16 17.8402 11.84 17.8402 11.65 17.6502Z"
  />
</template>
